
import './styles.css';
import InsaneTable from '../../component/insane-table'

function ProductionChecksheetEnum() {
    const tableOption = {
        tableName: "Enum",
        className: "",
        search: [
            {
                reqName: "enumid",
                displayName: "Enum ID",
                element: "input",
                placeholder: "Enter Enum ID."
            },
            {
                reqName: "enumcode",
                displayName: "Enum Code",
                element: "input",
                placeholder: "Enter Enum Code."
            },
            {
                reqName: "search_enumname",
                displayName: "Enum Name",
                element: "input",
                placeholder: "Enter Enum Name."
            }
        ],
        mapTable: [
            {
                displayName: "Enum ID",
                attName: "enumid",
                type: "text",
                form: {
                    validate: false,
                    enable: false,
                    element: "input"
                }
            },
            {
                displayName: "Enum Code",
                attName: "enumcode",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Enum Name",
                attName: "enumname",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Enum Value",
                attName: "enumvalue",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/pd/enum/get",
                dataReq: {
                    "index": 0,
                    "count": 10,
                    "enumid": "",
                    "enumcode": "",
                    "search_enumname": ""
                }
            },
            insert: {
                enable: true,
                url: "/admin/pd/enum/update",
                dataReq: {
                    "enumcode": "",
                    "enumname": "",
                    "enumvalue": ""
                }
            },
            update: {
                enable: true,
                url: "/admin/pd/enum/update",
                dataReq: {
                    "enumid": "",
                    "enumcode": "",
                    "enumname": "",
                    "enumvalue": ""
                }
            },
            delete: {
                enable: true,
                url: "/admin/pd/enum/delete",
                dataReq: {
                    "enumid": ""
                }
            }
        },
        action: [
            {
                name: "Edit",
                mode: "modal-form", /// page, modal, form
                option: {
                    type: "update"
                }
            }
        ]
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Enum of Equipment Management.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >
    );
}

export default ProductionChecksheetEnum;